import { component } from 'picoapp'
import Splide from '@splidejs/splide'

export default component((node) => {
  const sliderElement = node.querySelector('.splide')
  if (!sliderElement) return

  new Splide(sliderElement, {
    gap: 8,
    mediaQuery: 'min',
    padding: { right: 20 },
    pagination: false,
    arrows: true,
    breakpoints: {
      768: {
        destroy: true,
      },
    },
  }).mount()

  var originalTransform = null

  const sliderSlideLinks = node.querySelectorAll(
    '.collection-product-card-featured a:not(.purchase-btn-featured, .quick-add-btn-featured)'
  )
  sliderSlideLinks.forEach((slide) => {
    slide.addEventListener('click', (e) => {
      e.preventDefault()
      const slideProductHandle = slide.closest('[data-product-handle').getAttribute('data-product-handle')
      if (window?.gtag) {
        gtag('event', `Featured Product Section - Product Clicked`, {
          event_detail: `${slideProductHandle}`,
        })
      }

      // send intelligems event
      window.MicroBus.emit('igEvents:push', {
        event: 'Featured Product Section - Product Clicked',
        properties: { product: slideProductHandle },
      })

      window.location.href = slide.getAttribute('href')
    })
  })

  function setUpEventHandlersFeatured() {
    const reviewInterval = setInterval(function () {
      const nodeList = document.getElementsByClassName('stamped-badge-caption')
      for (let i = 0; i < nodeList.length; i++) {
        $(nodeList[i]).html('(' + $(nodeList[i]).data('reviews') + ')')
      }
      if (nodeList.length) clearInterval(reviewInterval)
    }, 10)

    $('.product-collection .select-flavour').click(function () {
      const parent = this.closest('.product-collection')
      $(parent).find('.select-flavour').removeClass('active')
      $(this).addClass('active')
      if ($(this).data('flavour') == 'variety') {
        $(this)
          .siblings('.flavour-text')
          .text($(this).data('flavour') + ' Pack')
      } else {
        $(this)
          .siblings('.flavour-text')
          .text($(this).data('flavour') + ' Flavor')
      }

      $('.product-collection-image img', $(this).closest('.product-collection')).hide()
      $('.product-collection-image img.image-' + $(this).data('flavour'), $(this).closest('.product-collection')).show()

      $('.for-lemon, .for-lime, .for-grapefruit, .for-variety', $(this).closest('.product-collection')).hide()
      $('.for-' + $(this).data('flavour'), $(this).closest('.product-collection')).show()
    })

    $('.collection-featured-products .normal-product-collection .button-wrapper .quick-add-btn').click(function () {
      if ($(this).hasClass('home-btn')) {
        var id = $(this).data('variantid')
        var qty = $(this).data('qty')
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: id,
            quantity: qty,
          },
          dataType: 'json',
          success: function () {
            window.MicroBus.emit(`side-cart:toggle`)
          },
        })
      } else {
        if ($(window).width() < 550) {
          var new_selected = $(this).closest('.product-collection-content').siblings('.purchase-modal')
          new_selected.css('display', 'flex')
          $('#gorgias-chat-container').hide()
          if ($(this).hasClass('quick-add-btn-featured')) {
            var slider_selected = $(this).closest('.splide__list')
            originalTransform = slider_selected.css('transform')
            slider_selected.addClass('transform-unset')
          }
        } else {
          const nodeList = document.querySelectorAll('.invert-desktop')
          for (let i = 0; i < nodeList.length; i++) {
            if (nodeList[i]) nodeList[i].style.display = 'none'
          }
          const nodeList2 = document.querySelectorAll('.normal-product-collection')
          for (let i = 0; i < nodeList.length; i++) {
            if (nodeList2[i]) nodeList2[i].style.display = 'flex'
          }
          var new_selected = $(this).closest('.product-collection')
          new_selected.find('.invert-desktop').css('display', 'flex')
          new_selected.find('.normal-product-collection').css('display', 'none')
          new_selected.find('.product-reviews-badge').css('display', 'none')
        }
      }
    })

    $('.collection-featured-products .invert-product-collection a.purchase-btn-featured').on('click', function (e) {
      e.preventDefault()
      e.stopImmediatePropagation()
      var id = $(this).data('variantid')
      var sellingPlan = $(this).data('selling-plan')

      var addItemToCart = function (variant_id, qty, selling_plan) {
        const data = {
          variant_id: variant_id,
          quantity: qty,
          selling_plan: selling_plan,
        }
        const parentHandle = $(e.target).closest('[data-product-handle]').data('product-handle')
        window.MicroBus.emit(`cart:add`, data)
        window.MicroBus.emit(`igEvents:push`, {
          event: `Featured Product Section - ATC`,
          properties: { product: parentHandle },
        })

        if (window?.gtag) {
          window.gtag('event', 'Featured Product Section - ATC', {
            event_detail: parentHandle,
          })
        }
      }

      addItemToCart(id, 1, sellingPlan)
    })
  }

  function setUpBodyEventHandlersFeatured() {
    $('body').click(function (e) {
      if ($(window).width() < 550) {
        if ($(e.target).hasClass('purchase-modal') || $(e.target).hasClass('close')) {
          $('.purchase-modal').css('display', 'none')
          var slider_selected = $(e.target).closest('.splide__list')
          slider_selected.removeClass('transform-unset')
          slider_selected.css('transform', originalTransform)
        }
      } else {
        if ($(e.target).hasClass('quick-add-btn')) {
        } else {
          const nodeList = document.querySelectorAll('.invert-desktop')
          for (let i = 0; i < nodeList.length; i++) {
            if (nodeList[i]) {
              nodeList[i].style.display = 'none'
            }
          }
          const nodeList2 = document.querySelectorAll('.normal-product-collection')
          for (let i = 0; i < nodeList.length; i++) {
            if (nodeList2[i]) {
              nodeList2[i].style.display = 'flex'
            }
          }
          const nodeList3 = document.querySelectorAll('.product-reviews-badge')
          for (let i = 0; i < nodeList3.length; i++) {
            if (nodeList3[i]) {
              nodeList3[i].style.display = 'block'
            }
          }
        }
      }
    })
    $('body').click(function (e) {
      if ($(e.target).hasClass('plan-btn') == false) {
        $('.quick-buy-modal').css('display', 'none')
        $('.plan_inner_content').css('display', 'flex')
      }
    })
  }

  $(document).ready(function () {
    setUpEventHandlersFeatured()
    setUpBodyEventHandlersFeatured()
  })
})
